import { EncrDecrService } from './services/utils/encr-decr.service';

export class AppConfig {

  public static googleMapsAPIEndpoint: string;
  public static googleMapsAPIKey: string;
  public static googleRecapchaSiteKey: string;

  public static userEmailID: string;
  public static baseURL: any;
  public static baseURLJP: any;
  public static baseURLFNOL: any;
  public static apiEndPoints: any = {};
  public static clientId: string;
  public static emailId: string;
  public static analyticsURL: string;
  public static analyticsURLJP: string;
  public static oktaConfig = {};
  public static apiBaseUrlLogin: string;
  public static baseURLOKTA: string;
  public static oktaUrl: string;
  public static authServerID: string;

  public static rumAccessToken: string;
  public static environment: string;
  public static cookieConsentFrameUrl: string;
  public static splunkRumWebUrl: string;
  public static splunkRumRecorderUrl: string;
  public static isSplunkRumEnabled: boolean = false;
  public static countryConfig: any = {
    'sg': {
      'countryKey': 'sg',
      'claimantPage.fields.name.postalCodeMandatory': true,
      'claimantPage.fields.name.insuredOccupationMandatory': true,
      'currencyKey': 'SGD',
      'consentRequired': true,
      'declarationRequired': true,
      'fnolDocs': 'common',
      'claimantPage.fields.name.policyNumberMandatory': false,
      'claimTypePage.augjson.name': 'fnol-claimtype-details',
      'paymentPage.component.name': 'PaymentSgComponent',
      'claimList': {
        'accident': {
          'medicalExpenseClaim': 'common',
          'leaveBenefit': 'common',
          'permanentDisability': 'common',
          'accidentalDeath': 'common',
          'otherClaim': 'common'
        },
        'travel': {
          'claimingIncident': 'common',
          'claimingDelayed': 'common',
          'claimingTrip': 'common',
          'claimingLost': 'common',
          'claimingOther': 'common'
        }
      }
    },
    'at': {
      'countryKey': 'at',
      'consentRequired': false,
      'declarationRequired': false,
      'claimantPage.fields.name.postalCodeMandatory': false,
      'claimantPage.fields.name.policyNumberMandatory': true,
      'fnolDocs': 'common',
      'claimTypePage.augjson.name': 'fnol-claimtype-details-at',
      'currencyKey': 'EUR',
      'paymentPage.component.name': 'PaymentCommonComponent',
      'claimList': {
        'accident': {
          'permanentDisability': 'custom',
          'accidentalDeath': 'custom',
          'otherClaim': 'custom'
        },
        'travel': {
          'claimingIncident': 'common',
          'claimingDelayed': 'common',
          'claimingTrip': 'common',
          'claimingLost': 'common',
          'claimingOther': 'common'
        }
      }
    },
    'au': {
      'countryKey': 'au',
      'fnolDocs': 'common',
      'consentRequired': true,
      'declarationRequired': false,
      'claimantPage.fields.name.postalCodeMandatory': true,
      'claimTypePage.augjson.name': 'fnol-claimtype-details-au',
      'claimantPage.fields.name.policyNumberMandatory': false,
      'currencyKey': 'AUD',
      'paymentPage.component.name': 'PaymentAuComponent',
      'claimList': {
        'accident': {
          'medicalExpenseClaim': 'common',
          'leaveBenefit': 'common',
          'permanentDisability': 'common',
          'accidentalDeath': 'common',
          'otherClaim': 'common'
        },
        'travel': {
          'claimingIncident': 'custom',
          'claimingDelayed': 'custom',
          'claimingTrip': 'custom',
          'claimingLost': 'custom',
          'myRentalVehicle': 'custom',
          'thirdPartyAffected': 'custom',
          'personalMoneyLost': 'custom',
          'claimingOther': 'custom'
        }
      }
    },
    'be': {
      'countryKey': 'be',
      'currencyKey': 'EUR',
      'consentRequired': true,
      'claimantPage.fields.name.postalCodeMandatory': true,
      'declarationRequired': false,
      'fnolDocs': 'custom/be',
      'claimantPage.fields.name.policyNumberMandatory': true,
      'claimTypePage.augjson.name': 'fnol-claimtype-details',
      'paymentPage.component.name': 'PaymentBeComponent',
      'claimList': {
        'accident': {
          'medicalExpenseClaim': 'common',
          'permanentDisability': 'common',
          'accidentalDeath': 'common',
          'otherClaim': 'common'
        },
        'travel': {
          'claimingIncident': 'common',
          'claimingDelayed': 'common',
          'claimingTrip': 'common',
          'claimingLost': 'common',
          'claimingOther': 'common'
        }
      }
    },
    'br': {
      'countryKey': 'br',
      'fnolDocs': 'common',
      'declarationRequired': false,
      'consentRequired': true,
      'claimantPage.fields.name.postalCodeMandatory': true,
      'paymentPage.component.name': 'PaymentCommonComponent',
      'claimTypePage.augjson.name': 'fnol-claimtype-details',
      'claimantPage.fields.name.policyNumberMandatory': true,
      'currencyKey': 'BRL',
      'claimList': {
        'accident': {
          'medicalExpenseClaim': 'common',
          'permanentDisability': 'common',
          'accidentalDeath': 'common',
          'otherClaim': 'common'
        },
        'travel': {
          'claimingIncident': 'common',
          'claimingDelayed': 'common',
          'claimingTrip': 'common',
          'claimingLost': 'common',
          'claimingOther': 'common'
        }
      }
    },
    'de': {
      'countryKey': 'de',
      'claimantPage.fields.name.postalCodeMandatory': false,
      'currencyKey': 'EUR',
      'fnolDocs': 'common',
      'claimantPage.fields.name.policyNumberMandatory': true,
      'claimTypePage.augjson.name': 'fnol-claimtype-details-de',
      'paymentPage.component.name': 'PaymentCommonComponent',
      'claimList': {
        'accident': {
          'permanentDisability': 'custom',
          'accidentalDeath': 'custom',
          'otherClaim': 'custom'
        },
        'travel': {
          'claimingIncident': 'common',
          'claimingDelayed': 'common',
          'claimingTrip': 'common',
          'claimingLost': 'common',
          'claimingOther': 'common'
        }
      }
    },
    'ca': {
      'countryKey': 'ca',
      'claimTypePage.augjson.name': 'fnol-claimtype-details-ca',
      'consentRequired': false,
      'declarationRequired': true,
      'currencyKey': 'CAD',
      'fnolDocs': 'common',
      'claimantPage.fields.name.policyNumberMandatory': true,
      'claimantPage.fields.name.postalCodeMandatory': true,
      'paymentPage.component.name': 'PaymentCaComponent',
      'claimList': {
        'accident': {
          'medicalExpenseClaim': 'custom',
          'permanentDisability': 'custom',
          'hospitalCash': 'custom',
          'leaveBenefit': 'custom',
          'fractureDislocation': 'custom',
          'accidentalDeath': 'custom',
          'criticalIllness': 'custom',
          'otherClaim': 'custom'
        },
        'travel': {
          'accidentOrIllness': 'custom',
          'claimingDelayed': 'custom',
          'claimingTrip': 'custom',
          'claimingLost': 'custom',
          'claimingOther': 'custom'
        }
      }
    },
    'ch': {
      'countryKey': 'ch',
      'fnolDocs': 'common',
      'consentRequired': true,
      'declarationRequired': false,
      'claimantPage.fields.name.postalCodeMandatory': false,
      'claimTypePage.augjson.name': 'fnol-claimtype-details-ch',
      'claimantPage.fields.name.policyNumberMandatory': true,
      'currencyKey': 'CHF',
      'paymentPage.component.name': 'PaymentCommonComponent',
      'claimList': {
        'accident': {
          'permanentDisability': 'custom',
          'accidentalDeath': 'custom',
          'otherClaim': 'custom'
        },
        'travel': {
          'claimingIncident': 'common',
          'claimingDelayed': 'common',
          'claimingTrip': 'common',
          'claimingLost': 'common',
          'claimingOther': 'common'
        }
      }
    },
    'fr': {
      'countryKey': 'fr',
      'fnolDocs': 'common',
      'claimantPage.fields.name.postalCodeMandatory': true,
      'claimTypePage.augjson.name': 'fnol-claimtype-details-fr',
      'claimantPage.fields.name.policyNumberMandatory': true,
      'currencyKey': 'EUR',
      'consentRequired': true,
      'declarationRequired': false,
      'paymentPage.component.name': 'PaymentFrComponent',
      'claimList': {
        'accident': {
          'medicalExpenseClaim': 'common',
          'leaveBenefit': 'common',
          'permanentDisability': 'common',
          'accidentalDeath': 'common',
          'otherClaim': 'common'
        },
        'travel': {
          'claimingIncident': 'common',
          'claimingDelayed': 'common',
          'claimingTrip': 'common',
          'claimingLost': 'common',
          'claimingOther': 'common'
        }
      }
    },
    'gb': {
      'countryKey': 'gb',
      'fnolDocs': 'common',
      'claimantPage.fields.name.postalCodeMandatory': true,
      'paymentPage.component.name': 'PaymentGbComponent',
      'claimantPage.fields.name.policyNumberMandatory': true,
      'claimTypePage.augjson.name': 'fnol-claimtype-details-gb',
      'declarationRequired': false,
      'consentRequired': false,
      'currencyKey': 'GBP',
      'claimList': {
        'accident': {
          'hospitalisation': 'custom',
          'fractureOrDislocation': 'custom',
          'disability': 'custom',
          'accidentalDeath': 'custom',
          'otherClaim': 'custom'
        },
        'travel': {
          'claimingIncident': 'custom',
          'claimingDelayed': 'custom',
          'cancelledOrCurtailed': 'custom',
          'claimingLost': 'custom',
          'claimingRentalVehicle': 'custom',
          'claimingOther': 'custom'
        }
      }
    },
    'hk': {
      'countryKey': 'hk',
      'fnolDocs': 'common',
      'claimantPage.fields.name.postalCodeMandatory': false,
      'consentRequired': true,
      'declarationRequired': true,
      'paymentPage.component.name': 'PaymentHkComponent',
      'claimTypePage.augjson.name': 'fnol-claimtype-details',
      'claimantPage.fields.name.policyNumberMandatory': true,
      'currencyKey': 'HKD',
      'claimList': {
        'accident': {
          'medicalExpenseClaim': 'common',
          'leaveBenefit': 'common',
          'permanentDisability': 'common',
          'accidentalDeath': 'common',
          'otherClaim': 'common'
        },
        'travel': {
          'claimingIncident': 'common',
          'claimingDelayed': 'common',
          'claimingTrip': 'common',
          'claimingLost': 'common',
          'claimingOther': 'common'
        }
      }
    },
    'ie': {
      'countryKey': 'ie',
      'fnolDocs': 'common',
      'declarationRequired': false,
      'consentRequired': false,
      'claimantPage.fields.name.postalCodeMandatory': true,
      'paymentPage.component.name': 'PaymentIeComponent',
      'claimTypePage.augjson.name': 'fnol-claimtype-details',
      'claimantPage.fields.name.policyNumberMandatory': true,
      'currencyKey': 'EUR',
      'claimList': {
        'accident': {
          'medicalExpenseClaim': 'common',
          'leaveBenefit': 'common',
          'permanentDisability': 'common',
          'accidentalDeath': 'common',
          'otherClaim': 'common'
        },
        'travel': {
          'claimingIncident': 'common',
          'claimingDelayed': 'common',
          'claimingTrip': 'common',
          'claimingLost': 'common',
          'claimingOther': 'common'
        }
      }
    },
    'mx': {
      'countryKey': 'mx',
      'fnolDocs': 'common',
      'declarationRequired': false,
      'consentRequired': true,
      'claimantPage.fields.name.postalCodeMandatory': true,
      'paymentPage.component.name': 'PaymentCommonComponent',
      'claimTypePage.augjson.name': 'fnol-claimtype-details',
      'claimantPage.fields.name.policyNumberMandatory': true,
      'currencyKey': 'MEX',
      'claimList': {
        'accident': {
          'medicalExpenseClaim': 'common',
          'permanentDisability': 'common',
          'accidentalDeath': 'common',
          'otherClaim': 'common'
        },
        'travel': {
          'claimingIncident': 'common',
          'claimingDelayed': 'common',
          'claimingTrip': 'common',
          'claimingLost': 'common',
          'claimingOther': 'common'
        }
      }
    },
    'my': {
      'countryKey': 'my',
      'claimantPage.fields.name.postalCodeMandatory': true,
      'currencyKey': 'MYR',
      'consentRequired': true,
      'declarationRequired': true,
      'fnolDocs': 'common',
      'claimTypePage.augjson.name': 'fnol-claimtype-details',
      'claimantPage.fields.name.policyNumberMandatory': true,
      'paymentPage.component.name': 'PaymentMyComponent',
      'claimList': {
        'accident': {
          'medicalExpenseClaim': 'common',
          'leaveBenefit': 'common',
          'permanentDisability': 'common',
          'accidentalDeath': 'common',
          'otherClaim': 'common'
        },
        'travel': {
          'claimingIncident': 'common',
          'claimingDelayed': 'common',
          'claimingTrip': 'common',
          'claimingLost': 'common',
          'claimingOther': 'common'
        }
      }
    },
    'nz': {
      'countryKey': 'nz',
      'claimantPage.fields.name.postalCodeMandatory': true,
      'consentRequired': true,
      'declarationRequired': false,
      'currencyKey': 'NZD',
      'fnolDocs': 'common',
      'claimTypePage.augjson.name': 'fnol-claimtype-details-nz',
      'paymentPage.component.name': 'PaymentNzComponent',
      'claimantPage.fields.name.policyNumberMandatory': false,
      'claimList': {
        'accident': {
          'medicalExpenseClaim': 'custom',
          'leaveBenefit': 'custom',
          'permanentDisability': 'custom',
          'accidentalDeath': 'custom',
          'otherClaim': 'custom'
        },
        'travel': {
          'claimingIncident': 'custom',
          'claimingDelayed': 'custom',
          'claimingTrip': 'custom',
          'claimingLost': 'custom',
          'myRentalVehicle': 'custom',
          'thirdPartyAffected': 'custom',
          'personalMoneyLost': 'custom',
          'claimingOther': 'custom'
        }
      }
    },
    'es': {
      'countryKey': 'es',
      'declarationRequired': false,
      'consentRequired': false,
      'claimantPage.fields.name.postalCodeMandatory': true,
      'claimTypePage.augjson.name': 'fnol-claimtype-details',
      'claimantPage.fields.name.policyNumberMandatory': true,
      'currencyKey': 'EUR',
      'fnolDocs': 'common',
      'paymentPage.component.name': 'PaymentEsComponent',
      'claimList': {
        'accident': {
          'medicalExpenseClaim': 'common',
          'leaveBenefit': 'common',
          'permanentDisability': 'common',
          'accidentalDeath': 'common',
          'otherClaim': 'common'
        },
        'travel': {
          'claimingIncident': 'common',
          'claimingDelayed': 'common',
          'claimingTrip': 'common',
          'claimingLost': 'common',
          'claimingOther': 'common'
        }
      },
      'footer': {
        'links': [
          {
            'label': 'Condiciones De Uso',
            'link': 'https://www.aig.com.es/condiciones-de-uso'
          },
          {
            'label': 'Aviso Legal',
            'link': 'https://www.aig.com/legal-notice'
          },
          {
            'label': 'De Privacidad',
            'link': 'https://www.aig.com.es/politica-de-privacidad'
          },
          {
            'label': 'Software Recomendado',
            'link': 'supported'
          }
        ],
        'copyrightText': 'Copyright © 2024 American International Group, Inc. Todos los derechos reservados.',
        'disclaimerText': 'American International Group, Inc. (AIG) es una organización global líder en seguros. Las compañías miembros de AIG ofrecen soluciones de seguros que ayudan a empresas y particulares en aproximadamente 70 países y jurisdicciones a proteger sus activos y gestionar riesgos. Las acciones habituales de AIG cotizan en la Bolsa de Valores de Nueva York.'
      },
      'privacy': {
        'links': [
          {
            'label': 'Terms Of Use',
            'link': 'https://www.aig.com.es/condiciones-de-uso'
          },
          {
            'label': 'Privacy Policy',
            'link': 'https://www.aig.com.es/politica-de-privacidad'
          }
        ]
      }
    },
    'pt': {
      'countryKey': 'pt',
      'fnolDocs': 'common',
      'consentRequired': true,
      'declarationRequired': false,
      'claimantPage.fields.name.postalCodeMandatory': true,
      'claimTypePage.augjson.name': 'fnol-claimtype-details',
      'claimantPage.fields.name.policyNumberMandatory': true,
      'currencyKey': 'EUR',
      'paymentPage.component.name': 'PaymentPtComponent',
      'claimList': {
        'accident': {
          'medicalExpenseClaim': 'common',
          'leaveBenefit': 'common',
          'permanentDisability': 'common',
          'accidentalDeath': 'common',
          'otherClaim': 'common'
        },
        'travel': {
          'claimingIncident': 'common',
          'claimingDelayed': 'common',
          'claimingTrip': 'common',
          'claimingLost': 'common',
          'claimingOther': 'common'
        }
      },
      'footer': {
        'links': [
          {
            'label': 'Termos de utilização',
            'link': 'https://www.aig.com.au/terms-of-use'
          },
          {
            'label': 'Privacidade',
            'link': 'https://www.aig.com.au/privacy-policy'
          },
          {
            'label': 'Aviso legal',
            'link': 'https://www.aig.com/legal-notice'
          },
          {
            'label': 'Software recomendado',
            'link': 'supported'
          }
        ],
        'copyrightText': 'Copyright © 2024 American International Group, Inc. Todos os direitos reservados.',
        'disclaimerText': 'A American International Group, Inc. (AIG) é uma organização líder global de seguros. As empresas associadas à AIG oferecem soluções de seguros que ajudam empresas e particulares em aproximadamente 70 países e jurisdições a proteger os seus ativos e a gerir riscos. As ações ordinárias da AIG estão cotadas na Bolsa de Nova Iorque.'
      },
      'privacy': {
        'links': [
          {
            'label': 'Terms Of Use',
            'link': 'https://www.aig.com.au/terms-of-use'
          },
          {
            'label': 'Privacy Policy',
            'link': 'https://www.aig.com.au/privacy-policy'
          }
        ]
      }
    },
    'us': {
      'countryKey': 'us',
      'claimantPage.fields.name.postalCodeMandatory': true,
      'consentRequired': false,
      'declarationRequired': true,
      'customDateFormat': 'MM/DD/YYYY',
      'currencyKey': 'USD',
      'fnolDocs': 'common',
      'claimantPage.fields.name.policyNumberMandatory': true,
      'claimTypePage.augjson.name': 'fnol-claimtype-details-us',
      'paymentPage.component.name': 'PaymentUsComponent',
      'claimList': {
        'accident': {
          'medicalExpenseClaim': 'custom',
          'permanentDisability': 'custom',
          'hospitalCash': 'custom',
          'leaveBenefit': 'custom',
          'fractureDislocation': 'custom',
          'accidentalDeath': 'custom',
          'criticalIllness': 'custom',
          'otherClaim': 'custom'
        },
        'travel': {
          'accidentOrIllness': 'custom',
          'claimingDelayed': 'custom',
          'claimingTrip': 'custom',
          'claimingLost': 'custom',
          'claimingOther': 'custom'
        }
      }
    },
    'za': {
      'countryKey': 'za',
      'claimantPage.fields.name.postalCodeMandatory': true,
      'claimTypePage.augjson.name': 'fnol-claimtype-details-za',
      'declarationRequired': false,
      'consentRequired': false,
      'currencyKey': 'ZAR',
      'fnolDocs': 'common',
      'claimantPage.fields.name.policyNumberMandatory': true,
      'paymentPage.component.name': 'PaymentZaComponent',
      'claimList': {
        'accident': {
          'medicalExpenseClaim': 'custom',
          'leaveBenefit': 'custom',
          'permanentDisability': 'custom',
          'accidentalDeath': 'custom',
          'otherClaim': 'custom'
        },
        'travel': {
          'claimingIncident': 'common',
          'claimingDelayed': 'common',
          'claimingTrip': 'common',
          'claimingLost': 'common',
          'claimingOther': 'common'
        }
      }
    },
    'nl': {
      'countryKey': 'nl',
      'claimantPage.fields.name.postalCodeMandatory': true,
      'currencyKey': 'EUR',
      'consentRequired': false,
      'declarationRequired': true,
      'fnolDocs': 'custom/nl',
      'claimantPage.fields.name.policyNumberMandatory': true,
      'claimTypePage.augjson.name': 'fnol-claimtype-details-nl',
      'paymentPage.component.name': 'PaymentCommonComponent',
      'claimList': {
        'accident': {
          'medicalExpenseClaim': 'custom',
          'accidentalDeath': 'common',
          'otherClaim': 'common'
        },
        'travel': {
          'claimingIncident': 'custom',
          'claimingDelayed': 'common',
          'claimingTrip': 'common',
          'claimingLost': 'common',
          'claimingOther': 'common'
        }
        }
    },
    
     'ec': {
      'countryKey': 'ec',
      'fnolDocs': 'common',
      'consentRequired': true,
      'declarationRequired': false,
      'claimantPage.fields.name.postalCodeMandatory': true,
      'claimTypePage.augjson.name': 'fnol-claimtype-details-ec',
      'claimantPage.fields.name.policyNumberMandatory': true,
      'currencyKey': 'USD',
      'paymentPage.component.name': 'PaymentCommonComponent',
      'claimList': {
        'accident': {
          'medicalExpenseClaim': 'custom',
          'hospitalCash': 'custom',
          'permanentDisability': 'custom',
          'fractureDislocation': 'custom',
          'accidentalDeath': 'custom',
          'otherClaim': 'custom'
        },
        'travel': {
          'claimingIncident': 'common',
          'claimingDelayed': 'common',
          'claimingTrip': 'common',
          'claimingLost': 'common',
          'claimingOther': 'common'
        }
      }
    },
  };
  public static setEnvConfig(config: any) {
    const decrypt = new EncrDecrService();
    for (const p in config) {
      if (config[p] === null || config[p] === undefined) {
        continue;
      }
      if (p !== 'countryConfig') {
        AppConfig[p] = config[p];
      }

      switch (p) {

        case 'rumAccessToken':
          this.rumAccessToken = decrypt.dataEncryptDecrypt(
            AppConfig[p],
            'decrypt'
          );
          break;
        case 'countryConfig':
          // Generated by AIG Copilot - start
          AppConfig.countryConfig = {
            ...AppConfig.countryConfig,
            ...config[p]
          };
          // Generated by AIG Copilot - end
          break;
        default:
          break;
      }
    }
  }

  public static loadSplunkRumScripts() {
    try {
      const nodeForSplunkWeb = document.createElement('script');
      nodeForSplunkWeb.type = 'text/javascript';
      nodeForSplunkWeb.src = AppConfig.splunkRumWebUrl;
      nodeForSplunkWeb.async = true;
      nodeForSplunkWeb.crossOrigin = 'anonymous';
      document.getElementsByTagName('head')[0]?.appendChild(nodeForSplunkWeb);

      const nodeForSplunkRecorder = document.createElement('script');
      nodeForSplunkRecorder.type = 'text/javascript';
      nodeForSplunkRecorder.src = AppConfig.splunkRumRecorderUrl;
      nodeForSplunkRecorder.async = true;
      nodeForSplunkRecorder.crossOrigin = 'anonymous';
      document.getElementsByTagName('head')[0]?.appendChild(nodeForSplunkRecorder);
    }
    catch (error) {
      console.error('Error loading Splunk RUM scripts:', error);
    }
  }

  public static getConfigUrl() {
    return 'config.json';
  }
}
